export type AccountSettingsPage =
  | null
  | 'organisation'
  | 'notifications'
  | 'team'
  | 'integrations'
  | 'profilePicture'
  | 'features'
  | 'assetTypes'
  | 'placeTypes'
  | 'contactTypes'
  | 'dateAndTime'
  | 'sharingPreferences'
  | 'referrals';

export const ACCOUNT_SETTINGS_PAGE_UNCHANGED = Symbol(
  'account-settings-page-unchanged'
);

type ManagedAccountSettingsPage = 'placeTypes' | 'contactTypes' | 'assetTypes';

const MANAGED_ACCOUNT_PAGES = new Set<ManagedAccountSettingsPage>([
  'placeTypes',
  'contactTypes',
  'assetTypes',
]);

const ACCOUNT_SETTINGS_HASH_PAGES = [
  'placeTypes',
  'contactTypes',
  'assetTypes',
  'features',
  'dateAndTime',
  'sharingPreferences',
  'organisation',
  'team',
  'profilePicture',
  'referrals',
] as const;

export function resolveAccountSettingsPage(
  hash: string,
  options: { canManageAccount: boolean; showSettings: boolean }
): AccountSettingsPage | typeof ACCOUNT_SETTINGS_PAGE_UNCHANGED {
  for (const page of ACCOUNT_SETTINGS_HASH_PAGES) {
    if (!hash.endsWith(`:${page}`)) continue;

    if (MANAGED_ACCOUNT_PAGES.has(page as ManagedAccountSettingsPage)) {
      return options.canManageAccount ? page : null;
    }

    return page;
  }

  if (!options.showSettings) {
    return null;
  }

  return ACCOUNT_SETTINGS_PAGE_UNCHANGED;
}
